import * as z from "zod/v4";

export const pickWorkOrderLine = {
  name: "pickWorkOrderLine" as const,
  input: z.object({
    pickLineId: z.string(),
    quantityPicked: z.number().int().nonnegative(),
    sessionId: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
